import type { Theme, Components } from '@mui/material/styles';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    input: {
      '&:autofill': {
        '&, &:hover, &:focus, &:active': {
          backgroundColor: 'transparent !important',
          color: 'currentColor !important',
        },
      },
    },

    root: ({ theme }) => ({
      gap: theme.spacing(1),
      '& svg': {
        color: theme.palette.action.active,
      },

      '&.Mui-error:is(:hover, :focus)': {
        '&:before, &:after': {
          borderBottomColor: theme.palette.error.light,
        },
      },

      // Changed fields (see FieldRevert) get a yellow underline instead of white.
      // Error styling still wins via :not(.Mui-error).
      '[data-field-dirty="true"] &:not(.Mui-error)': {
        '&:before, &:after': {
          borderBottomColor: theme.palette.warning.main,
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottomColor: theme.palette.warning.main,
        },
      },
    }),
  },
};
